// Vendor Libs
import {useDispatch, useSelector} from 'react-redux';

// Redux Actions
import {
  addShelf,
  createStorefront,
  removeShelf,
  resetStorefront,
  setStorefrontData,
  setMode,
  updateStorefront,
} from '../redux/actions/storefront-actions';

export const useStorefront = () => {
  const dispatch = useDispatch();

  return {
    addShelf: (...args) => dispatch(addShelf(...args)),
    createStorefront: (...args) => dispatch(createStorefront(...args)),
    storefrontData: useSelector(({storefront: {storefrontData} = {}}) => storefrontData),
    mode: useSelector(({storefront: {mode} = {}}) => mode),
    removeShelf: (...args) => dispatch(removeShelf(...args)),
    resetStorefront: () => dispatch(resetStorefront()),
    setStorefrontData: (...args) => dispatch(setStorefrontData(...args)),
    setMode: (...args) => dispatch(setMode(...args)),
    updateStorefront: (...args) => dispatch(updateStorefront(...args)),
  };
};
